/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Keep search-result visits on the production home page.
};

//SEO Related settings
const seo = {
  title: "ZentoAI | AI 보안 솔루션",
  description:
    "ZentoAI는 AI 보안 점검, LLM 취약점 분석, 프롬프트 인젝션 테스트, 레드팀 자동화, 보안 워크플로우 구축을 지원하는 AI 보안 솔루션입니다.",
  keywords:
    "ZentoAI, 젠토AI, ZENTO, AI 보안 솔루션, AI 보안, LLM 취약점 분석, 프롬프트 인젝션, 레드팀 자동화, 보안 자동화, AI Security",
  image: "https://zento.im/icons/desc.png",
  imageAlt: "ZentoAI AI 보안 솔루션 로고",
  locale: "ko_KR",
  og: {
    title: "ZentoAI | AI 보안 솔루션",
    type: "website",
    url: "https://zento.im/",
  },
};

//Home Page
const greeting = {
  title: "ZENTO",
  logo_name: "ZENTO",
  nickname: "생산성에 집착하는 AI Native Team",
  subTitle:
    "제품, 비즈니스, AI 자동화를 하나의 실행력으로 연결합니다.",
  resumeLink:
    "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
  portfolio_repository: "https://github.com/ashutosh1919/masterPortfolio",
  githubProfile: "https://github.com/ashutosh1919",
};

const team = {
  intro: {
    title: "생산성에 집착하는 실전형 AI Native 조직, ZENTO",
    description:
      "ZENTO는 AI·속도·자동화·데이터를 핵심 업무 철학으로 삼고, 생산성에 집착하는 사람들이 모인 팀입니다.",
    logoSymbol: "",
    logoWordmark: "",
    principles: [
      {
        label: "AI",
        title: "AI의 역할을 새롭게 정의합니다.",
        body:
          "전 구성원이 Cursor, Claude Code를 실무에 직접 활용합니다. AI는 더 이상 도구가 아니며, 동등한 팀원입니다. 중앙 데이터 기반으로 운영되는 군집 Agent를 통해 가장 빠르게 최신 기술을 실험하고 실무에 적용합니다.",
      },
      {
        label: "Speed",
        title: "매출 350억 스케일업을 이끈 성장 DNA",
        body:
          "2년 만에 350억 매출을 달성한 스타트업에서의 업무 방식을 그대로 이식했습니다. 기획부터 배포, 고객 피드백 수용까지의 사이클을 업계 최고 수준으로 단축하여 기민하게 대응합니다.",
      },
      {
        label: "Automation",
        title: "초격차 효율의 자동화 워크플로우",
        body:
          "단순 반복 업무를 제로화했습니다. 소셜 미디어 트렌드 조기 탐지부터 데이터 분석, 예측 모델을 활용한 정밀한 타겟팅 및 마케팅 최적화까지, 소수 정예로 대규모 플랫폼 운영이 가능한 인프라를 구축했습니다.",
      },
      {
        label: "Data",
        title: "수치 중심의 정밀한 의사결정",
        body:
          "자동화 시스템으로 수집·정제된 학습자 행동 및 시장 데이터를 근거로 판단합니다. 주관으로 입증되지 않는 모든 아이디어는 즉각 폐기하며, 오직 데이터가 지시하는 수치 기반의 실행안을 따릅니다.",
      },
    ],
  },
  title: "리더십 팀",
  subtitle:
    "ZENTO를 함께 만들어가는 핵심 멤버를 소개합니다.",
  members: [
    {
      name: "홍승현 SeungHyun Hong",
      focus: "팀 리더 (Team Leader)",
      focusColor: "#a79f8b",
      image: "hyerim-jeong-new.png",
      bio:
        "ZENTO의 사업 방향, 파트너십, 운영 리듬을 이끌며 초기 아이디어를 실행 가능한 시장 전략으로 구체화합니다.",
      history: [
        {
          label: "학력",
          body:
            "과학고 조기졸업 후 연세대학교 기계공학과·나노공학과 졸업, 서울대학교 반도체 공정실습 수료",
        },
        {
          label: "연구",
          body: "연세대학교–삼성 R&D 나노구조체 기반 반도체 광소자 연구",
        },
        {
          label: "지식재산",
          body:
            "LLM 언어학습모델 특허 2건 보유·3건 출원, 업무·공간운영 소프트웨어 특허 출원으로 기술 자산 축적",
        },
      ],
    },
    {
      name: "정혜림 Hyerim Jeong",
      focus: "프로덕트 빌더 (Product Builder)",
      focusColor: "#9fc8e8",
      image: "seunghyun-hong-new.png",
      bio:
        "사용자 문제 발견부터 로드맵 우선순위, 출시 경험까지 제품의 흐름을 설계하고 완성도를 높입니다.",
      history: [
        {
          label: "학력",
          body: "연세대학교 영어영문학과 심화전공 졸업",
        },
        {
          label: "프로덕트",
          body:
            "GloZ Inc.에서 4개국 기반 글로벌 프로덕트 매니저로 제품 기획부터 출시까지 총 3년간 주도, Series A 투자를 완료한 글로벌 현지화 협업 플랫폼(MAU 2,000) 'E'nuff'를 데이터 기반으로 운영",
        },
        {
          label: "데이터 기반 성과",
          body:
            "유저 행동 데이터 분석으로 정산 정보 등록 완료율 81%p 상승·관련 VoC 86% 감소, 정성 데이터 기반 검색 기능 개선으로 기능 사용률 38%p 성장",
        },
        {
          label: "AI 트레이닝",
          body:
            "Scale AI에서 Korean Language AI Trainer로 한국어 데이터 품질 설계",
        },
        {
          label: "데이터·품질",
          body:
            "콘텐츠 추천 OTT 왓챠(Watcha)에서 Quality Control을 맡아 서비스 데이터 정합성 관리",
        },
      ],
    },
    {
      name: "박종서 Jongseo Park",
      focus: "전방배치 엔지니어 (AI Forward Deployed Engineer)",
      focusColor: "#111111",
      darkFocusOutline: true,
      image: "jongseo-park-new.png",
      bio:
        "AI 전략과 자동화 시스템을 설계하며 반복 가능한 실행 구조와 업무 지능화를 만들어갑니다.",
      history: [
        {
          label: "AI 보안",
          body:
            "Anthropic 비공개 보안 테스터로 초청, 레드팀 챌린지 전 세계 13,960명 중 339명(상위 2.4%)만 성공한 Jailbreak를 달성하고 글로벌 AI 서비스 버그 바운티에서 크리티컬 취약점을 다수 제보",
        },
        {
          label: "알고리즘",
          body:
            "AI 활용 알고리즘 최적화로 5년간 유지된 세계 기록을 경신하며 세계 1위 기록을 다수 보유",
        },
        {
          label: "스케일업",
          body:
            "자본금 200만 원에서 2년 만에 연매출 350억을 달성한 스타트업의 디지털 혁신본부 초기 멤버로 합류",
        },
        {
          label: "AI 자동화",
          body:
            "의료·금융·컨설팅 3개 회사 16개 팀에 60개 워크플로우를 구축해 12개월간 약 22,800시간(풀타임 11명 분량)을 절감하고, 100시간 작업을 10분으로 단축(99.8%↓)하여 연 3억 원 가치를 창출",
        },
        {
          label: "솔로프리너",
          body:
            "스마트스토어·쿠팡 운영 전 과정을 95% 자동화해 마진율 80%를 달성하고, AI 상세페이지로 3주 만에 월매출 900만 원·쿠팡 키워드 1위를 기록",
        },
      ],
    },
    {
      name: "김세현 Saihyun Kim",
      focus: "전략/마케팅 (Strategic/Marketing)",
      focusColor: "#7f8da0",
      focusOutline: true,
      image: "kim-sehyun.png",
      bio:
        "고객 인사이트, 시장 분석, 캠페인 전략을 바탕으로 ZENTO의 성장 방향과 브랜드 확산을 설계합니다.",
      history: [
        {
          label: "학력",
          body:
            "University of Pennsylvania, Wharton School 졸업, 마케팅·비즈니스 애널리틱스 전공",
        },
        {
          label: "전략 총괄",
          body:
            "라이온 아카데미(Lion Academy) 프로그램 총괄 디렉터로 글로벌 진학 전략을 수립",
        },
        {
          label: "마케팅 실무",
          body:
            "B2C 서비스 '사주핑'의 마케팅 매니저로 브랜딩 전략을 수립하고 유저 데이터 기반으로 서비스를 기획·운영",
        },
        {
          label: "평가·인사이트",
          body:
            "UPenn 공식 면접관으로 지원자를 직접 평가하며 사람이 무엇에 반응하고 선택하는지를 평가자 관점에서 체득",
        },
      ],
    },
    {
      name: "김민재 Minjae Kim",
      focus: "백엔드 개발자 (Backend Developer)",
      focusColor: "#267d78",
      image: "minjae-kim.jpeg",
      bio:
        "서비스 운영에 필요한 백엔드 구조와 데이터 흐름을 설계하며, 안정적인 시스템과 자동화 인프라를 구현합니다.",
      history: [
        {
          label: "학력",
          body:
            "연세대학교 컴퓨터과학과 학사, 삼성 대학생 프로그래밍 경진대회(SCPC) 본선 진출 및 교내 프로그래밍 경진대회 은상",
        },
        {
          label: "백엔드",
          body:
            "DAU 1,000명 규모 데이팅 앱 'Solt'를 공동창업하고 백엔드 설계부터 운영까지 전담",
        },
        {
          label: "데이터",
          body:
            "Blank Corp에서 20여 개 브랜드의 전사 판매 데이터 파이프라인과 내부 대시보드를 구축",
        },
        {
          label: "글로벌 서비스",
          body:
            "글로벌 대화 서비스 '심심이(SimSimi)'의 백엔드를 유지보수하고 신규 웹 기능을 개발",
        },
        {
          label: "블록체인",
          body:
            "NFT 스타트업 StudioXYZ를 공동창업해 'Crazy Rich Yellows'·'Waltz Movement' 시스템을 개발하고 전시를 진행",
        },
      ],
    },
  ],
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/ashutosh1919",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ashutosh1919/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/DevSense19",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:ashutoshhathidara98@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://twitter.com/ashutosh_1919",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/laymanbrother.19/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/layman_brother/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "AI 전략과 자동화",
      fileName: "DataScienceImg",
      skills: [
        "반복 업무를 줄이고 의사결정을 빠르게 만드는 AI 활용 전략을 설계합니다.",
        "팀과 고객이 바로 사용할 수 있는 자동화 워크플로를 구축합니다.",
        "실험 결과를 데이터로 확인하며 실행 방식을 계속 개선합니다.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "제품 기획과 실행",
      fileName: "FullStackImg",
      skills: [
        "사용자 문제를 발견하고 제품 방향과 우선순위를 정리합니다.",
        "아이디어를 화면, 기능, 운영 프로세스로 빠르게 구체화합니다.",
        "출시 이후에도 피드백을 반영해 제품 경험을 다듬습니다.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "비즈니스 운영",
      fileName: "CloudInfraImg",
      skills: [
        "파트너십, 세일즈, 운영 지표를 연결해 실행 가능한 사업 구조를 만듭니다.",
        "작은 팀이 빠르게 움직일 수 있도록 의사결정과 협업 흐름을 정리합니다.",
        "시장 반응을 바탕으로 다음 액션과 성장 방향을 설계합니다.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    {
      title: "브랜드와 성장",
      fileName: "DesignImg",
      skills: [
        "고객이 이해하기 쉬운 메시지와 브랜드 톤을 만듭니다.",
        "캠페인 실험과 콘텐츠 운영으로 도달과 전환을 높입니다.",
        "데이터 기반으로 성장 채널을 검증하고 확장합니다.",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Indian Institute of Information Technology Kurnool",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "http://iiitk.ac.in",
    },
    {
      title: "Indiana University Bloomington",
      subtitle: "M.S. in Computer Science",
      logo_path: "iu_logo.png",
      alt_name: "Indiana University Bloomington",
      duration: "2021 - 2023",
      descriptions: [
        "I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
        "Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
        "During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
      ],
      website_link: "https://www.indiana.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "TikTok Inc.",
          company_url: "https://www.tiktok.com/en/",
          logo_path: "tiktok_logo.png",
          duration: "June 2023 - Present",
          location: "San Jose, CA, USA",
          description:
            "Improving ads ranking models on the core TikTok product. Experience working on modeling two-tower architectures like DeepFM, Wide & deep learning, etc. Working on Large Language Models (LLM) pretraining and Large Multi-modal Model (LMM) finetuning strategies.",
          color: "#000000",
        },
        {
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - Aug 2021",
          location: "Hyderabad, Telangana",
          description:
            "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description:
            "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Machine Learning Intern",
          company: "TikTok Inc.",
          company_url: "https://www.tiktok.com/en/",
          logo_path: "tiktok_logo.png",
          duration: "May 2022 - Aug 2022",
          location: "San Francisco, USA",
          description:
            "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
          color: "#000000",
        },
        {
          title: "Data Science Research Intern",
          company: "Delhivery Pvt. Ltd.",
          company_url: "https://www.delhivery.com/",
          logo_path: "delhivery_logo.png",
          duration: "May 2019 - Sept 2019",
          location: "Gurgaon, Haryana",
          description:
            "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
          color: "#ee3c26",
        },
        {
          title: "Data Science Intern",
          company: "Intel Indexer LLC",
          company_url:
            "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
          logo_path: "intel_logo.jpg",
          duration: "Nov 2018 - Dec 2018",
          location: "Work From Home",
          description:
            "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 2019 - April 2020",
          location: "Hyderabad, Telangana",
          description:
            "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Aug 2019 - May 2020",
          location: "Hyderabad, Telangana",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "DSC IIITDM Kurnool",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Kurnool, Andhra Pradesh",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
    locality: "San Jose",
    country: "USA",
    region: "California",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  team,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
